import { Popper, PopperPlacementType, PopperProps } from '@mui/material';
import { Z_INDEX } from '@/Theme';

// Custom Popper component to control dropdown positioning
function CustomPopper(
  props: PopperProps,
  fixedFlip: boolean = false,
  placement: PopperPlacementType = 'bottom-start'
) {
  return (
    <Popper
      {...props}
      data-cy="custom-popper"
      placement={placement}
      popperOptions={{
        modifiers: [
          {
            name: 'flip',
            enabled: fixedFlip
          }
        ]
      }}
      sx={{
        zIndex: `${Z_INDEX.SIDEBAR + 99999999999} !important`
      }}
    />
  );
}

export default CustomPopper;
